import { Typography, Button, Modal } from "@mui/material";
import { Link } from "react-router-dom";
import { useAPI } from "../../API/useAPI";
import DeleteIcon from "@mui/icons-material/Delete";
import { useContext, useEffect, useState } from "react";
import { SnackbarContext } from "../../contexts/SnackbarProvider";
import { useConfirm } from "material-ui-confirm";

interface Props {
  id: number;
  signalFetchJourReports: () => void;
}

/**
 * Button to delete report
 *
 *
 * @param {id, refetchReports}
 * @returns
 */
export default function DeleteReportButton({
  id,
  signalFetchJourReports,
}: Props) {
  const snackBar = useContext(SnackbarContext);
  const api = useAPI();
  const confirm = useConfirm();
  const [deleteReport, setDeleteReport] = useState(false);

  useEffect(() => {
    const handleDelete = async () => {
      console.log("this is run");
      console.log("should delete: ", deleteReport);
      if (deleteReport) {
        setDeleteReport(false);

        const res = await api.jourReports.delete(id);

        if (res.error) {
          snackBar.show("Kunde inte radera rapport.", "error");
        } else {
          snackBar.show("Rapport raderad", "success");
        }
        signalFetchJourReports();
      }
    };

    handleDelete();
  }, [deleteReport, setDeleteReport, id, snackBar]);

  const handleButtonPress = () => {
    confirm({
      title: "Är du säker?",
      confirmationText: "Radera rapport",
      cancellationText: "Avbryt",
      confirmationButtonProps: { autoFocus: true },
      allowClose: true,
    })
      .then(() => {
        console.log("delete report!");
        setDeleteReport(true);
      })
      .catch(() => {
        console.log("not deleting any report");
      });
  };

  return (
    <Button
      component={Link}
      to=""
      sx={{
        border: 1,
        borderColor: "info.light",
        borderRadius: "10px",
      }}
      startIcon={<DeleteIcon />}
      variant="outlined"
      onClick={handleButtonPress}
    >
      <Typography>Radera rapport</Typography>
    </Button>
  );
}
